/* eslint-disable */
import LegacyNode from "./LegacyNode";
import ModernNode from "./ModernNode";

function CustomNode(props) {
	const { newProcessFlow } = props;
	const isNewProcessFlow = newProcessFlow;

	if (isNewProcessFlow) {
		return (
			<ModernNode {...props} />
		)
	} else {
		return (
			<LegacyNode {...props} />
		)
	}
}


export default CustomNode;